import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  TextField,
  FormHelperText,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React from "react";

interface IInputProps {
  type?: any;
  value?: string | number;
  direction?: "rtl" | "ltr";
  name?: string;
  handelChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handelOnBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: boolean;
  errorMessage?: string | false;
  placHolder?: string;
  textArea?: boolean;
  placHolderSize?: number;
  disabled?: boolean;
  endAdornment?: JSX.Element;
  startAdornment?: JSX.Element;
}

export default function CustomPasswordInput({
  disabled,
  textArea = false,
  direction = "rtl",
  handelChange,
  handelOnBlur,
  type,
  name,
  error,
  errorMessage,
  placHolder = "نام کاربری خود را وارد کنید...",
  placHolderSize = 14,
  value,
  endAdornment,
  startAdornment,
}: IInputProps) {
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  return (
    <TextField
      type={showPassword ? "text" : "password"}
      value={value}
      rows={3}
      multiline={textArea}
      helperText={
        <FormHelperText
          style={{
            padding: "0px",
            margin: "0px",
            color: "red",
            direction: "rtl",
            textAlign: "right",
            fontSize: 13,
          }}
        >
          {errorMessage}
        </FormHelperText>
      }
      disabled={disabled}
      error={error}
      name={name}
      onChange={handelChange}
      onBlur={handelOnBlur}
      placeholder={placHolder}
      InputLabelProps={{ shrink: false }}
      size="medium"
      id="outlined-basic"
      variant="outlined"
      inputProps={{ inputMode: type, pattern: "[1-9]*" }}
      InputProps={{
        style: {
          fontSize: "14px",
          direction: direction || "rtl",
          // height: "46px",
        }, // Adjust the font size as needed
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {!showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
        startAdornment: startAdornment,
      }}
      sx={{
        outline: "none",
        border: "none",
        width: "100%",
        "& input::placeholder": {
          fontSize: placHolderSize,
        },
        "& .MuiInputBase-root": {
          padding: "0px 0px 0px 0px",
        },
        "& .MuiInputBase-input": {
          padding: textArea
            ? "0px 0px"
            : startAdornment
            ? "12px 8px"
            : "12px 16px",
          fontSize: "14px",
        },
        "& .MuiFormLabel-root": {
          fontSize: "14px",
        },
      }}
    />
  );
}
